import axios from 'axios';

export default {
  requestBrochures({
    state,
    commit
  }) {
    return axios
      .get(state.data.brochuresUrl)
      .then(response => {
        commit('setBrochureData', response.data);
      });
  },
  submitBrochure({
    state,
    commit,
    getters
  }, utmParams) {
    commit('setLoading', true);

    // build user data to send to API
    const formData = {
      ...getters.formData,
      dateOrdered: new Date().toJSON(), // Add date/time of submission
      brochureIds: getters.brochureSelection.map(brochure => brochure.code), // Add brochure IDs
      utmSource: utmParams.utmSource, // Add UTM source
      utmMedium: utmParams.utmMedium, // Add UTM medium
    };

    // Add address into suitable format for API
    formData.address.addressLines = Object.keys(formData.address.addressLines).map(k => formData.address.addressLines[k]);

    return axios
      .post(state.data.submitRequestUrl, formData)
      .then(() => {
        GTM.brochureRequestPost(formData.brochureIds, {
          country: formData.address.country,
          city: formData.address.town,
          email: formData.email,
          firstName: formData.firstName,
          lastName: formData.lastName,
          postal: formData.address.postCode,
          referralSource: formData.utmSource,
          referralDetail: formData.utmMedium,
          phone: formData.phoneNumber
        }, 'post');
        window.location.href = state.data.thankYouPageUrl;
      })
      .catch(error => {
        if (error.response) {
          commit('setLoading', false);
          commit('setApiError', true);
          commit('setApiErrorMessage', error.response.data.exception.message);
        }
      });
  }
}
